import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import ptBR from "antd/lib/locale/pt_BR";
import moment from "moment";
import "moment/locale/pt-br";

import { AuthProvider } from "./auth";
import { ToastProvider } from "./toast";

const AppProvider: React.FC = ({ children }) => {
  useEffect(() => {
    moment.locale("pt");
  }, []);
  return (
    <AuthProvider>
      <ToastProvider>
        <ConfigProvider locale={ptBR}>{children}</ConfigProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default AppProvider;
